import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import { initSentry } from './App/sentry';
import { initializeAuth } from './apollo/apolloClient';
import { authService } from './Auth/authService';

import './styles/main.css';

initSentry();
initializeAuth(authService);

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <StrictMode>
    <App />
  </StrictMode>,
);
